import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { FaMailBulk } from 'react-icons/fa';
import * as CONSTANTS from "../../CONSTANTS";
import { toast } from 'react-toastify';

function SocialsShare({eventId, eventTitle}) {

    const currentUrl                                             = window.location.href;
    const [randomNumber, setRandomNumber]                        = useState("1");
    const [showEmailList,setShowEmailList]                       = useState(false);

    const [sendEmail, setSendEmail]                              = useState(false);

    const [emailList, setEmailList] = useState([]);
    const [inputEmail, setInputEmail] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        let number = Math.floor(Math.random() * 5) + 1;
        setRandomNumber(number);
    },[]);


  // simple regex for email validation
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email.toLowerCase());
  };

  const handleAddEmail = () => {
    if (!inputEmail.trim()) {
      setError("Email cannot be empty");
      return;
    }
    if (!validateEmail(inputEmail)) {
      setError("Invalid email format");
      return;
    }
    if (emailList.includes(inputEmail)) {
      setError("Email already added");
      return;
    }

    setEmailList([...emailList, inputEmail]);
    setInputEmail("");
    setError("");
  };

  const handleRemoveEmail = (email) => {
    setEmailList(emailList.filter((e) => e !== email));
  };

  // Handle Email Share
  const handleEmailShare = async () => {
     console.log(eventId);
     console.log(emailList);
     console.log(eventTitle);
     try {
      
      const content = {
          "link" :  currentUrl,
          "couple" :  eventTitle,
          "emails" :  emailList,
        }
        setSendEmail(true);
        const results = await axios.put(CONSTANTS.API_URL +"auth/email/share/v1", content);
        setSendEmail(false);
        toast.success(results.data.message);
     }catch(err){
      console.log(err);
      setSendEmail(false);
     }
  };


  return (
    <div className="section-socials"
        style={{ backgroundImage:`url('https://lovedripp.co.za/assets/images/social${randomNumber}.jpg')` }}>
        <div className="overlay-socials">
            <div className="social">
                <div className="social-box-middle">
                    <p className="t-part">Share</p>

                        {/* Email Share */}
                        <button
                        onClick={() => setShowEmailList(true)}
                        className="px-3 py-1 rounded btn-main mr-2"
                        >
                        Email Invite
                        </button>

                        {/* WhatsApp */}
                        <a
                        href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                            currentUrl
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-3 py-1 rounded bg-green-500 text-white mr-2"
                        >
                        WhatsApp
                        </a>

                        {/* Facebook */}
                        <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                            currentUrl
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-3 py-1 rounded bg-blue-800 text-white mr-2"
                        >
                        Facebook
                        </a>

                        {/* Twitter 
                        <a
                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                            currentUrl
                        )}&text=Check this out!`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="px-3 py-1 rounded bg-sky-500 text-white"
                          >
                        Twitter
                        </a>
                        */}
                </div>
                {
                  showEmailList && (
                      <div className="toemail-list">
                        <div className="email-to-body">
                            <div className="email-header">
                              Add Emails to share
                              <button className="btn btn-close"
                                onClick={() => setShowEmailList(false)}></button>
                            </div>
                            <div className="email-list">
                              <div className="email-input d-flex mt-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter email"
                                  value={inputEmail}
                                  onChange={(e) => setInputEmail(e.target.value)}
                                  onKeyDown={(e) => e.key === "Enter" && handleAddEmail()}
                                />
                                <button className="btn btn-primary ms-2" onClick={handleAddEmail}>
                                  Add
                                </button>
                              </div>

                            </div>
                            {error && <div className="text-danger mt-2 text-center">{error}</div>}
                            <div className="email-list mt-3">
                                {emailList.map((email, index) => (
                                  <div
                                    key={index}
                                    className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                                  >
                                    <span>{email}</span>
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() => handleRemoveEmail(email)}
                                    >
                                      Remove
                                    </button>
                                  </div>
                                ))}
                            </div>
                            {
                              emailList.length > 0 &&(
                               <div className="p-2 text-center">
                                 <button className="btn btn-main"
                                    onClick={handleEmailShare}>
                                       {
                                        sendEmail ? 'loading' : <span>Send <FaMailBulk /></span>
                                       }
                                    
                                  </button>
                               </div>
                              )
                            }
                        </div>
                      </div>
                  )
                }
                
            </div>
        </div>
    </div>
  )
}

export default SocialsShare